import type { CommentStatus } from '@/services/comments/types';
import type { useTranslations } from 'next-intl';

type TranslateFn = ReturnType<typeof useTranslations>;

const STATUS_KEY_MAP: Record<CommentStatus, string> = {
  UNKNOWN_STATUS: 'get-feedback-status-open',
  OPEN: 'get-feedback-status-open',
  NEW: 'get-feedback-status-new',
  RESOLVED: 'get-feedback-status-resolved',
};

export function getCommentStatusLabel(
  status: CommentStatus | null | undefined,
  t: TranslateFn,
): string {
  return t(status ? STATUS_KEY_MAP[status] : 'get-feedback-status-open');
}
